export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/en.acf8510b.svg","height":30,"width":60,"blurWidth":0,"blurHeight":0};